<nb-card class="detail-dialog">
  <nb-card-header>
    <div class="detail-dialog__head">
      <div>
        <h5>{{ userName() }}</h5>
        <p class="muted">{{ user.email || '—' }} · #{{ user.moodle_user_id }}</p>
      </div>
      <button nbButton ghost size="small" (click)="ref.close()" aria-label="Schließen">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div *ngIf="loading" class="detail-dialog__loading">
      <nb-spinner status="basic"></nb-spinner>
    </div>

    <div *ngIf="!loading && rows.length === 0" class="detail-dialog__empty">
      {{ 'pages.moodle.detail.noCourses' | translate }}
    </div>

    <ng-container *ngIf="!loading && rows.length > 0">
      <div class="detail-dialog__section-title">
        {{ 'pages.moodle.detail.coursesHeader' | translate:{ count: rows.length } }}
      </div>
      <div *ngFor="let r of rows; trackBy: trackRow" class="detail-dialog__course-block">
        <div class="detail-dialog__course-head">
          <strong>{{ r.course_fullname || r.course_shortname || ('Kurs #' + r.moodle_course_id) }}</strong>
          <span class="muted">
            {{ r.course_shortname || '—' }} · #{{ r.moodle_course_id }}
            <span *ngIf="r.role"> · {{ r.role }}</span>
          </span>
        </div>

        <div *ngIf="totalGrades(r) === 0" class="detail-dialog__no-grades muted">
          {{ 'pages.moodle.detail.noGrades' | translate }}
        </div>

        <table *ngIf="totalGrades(r) > 0" class="detail-dialog__grades">
          <thead>
            <tr>
              <th>{{ 'pages.moodle.col.gradeItem' | translate }}</th>
              <th>{{ 'pages.moodle.col.gradeType' | translate }}</th>
              <th>{{ 'pages.moodle.col.grade' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of r.grades">
              <td>{{ g.item_name || '—' }}</td>
              <td class="muted">{{ g.item_type || '—' }}</td>
              <td class="muted">
                {{ g.grade_formatted || (g.raw_grade !== null ? g.raw_grade : '—') }}
                <span *ngIf="g.grade_max !== null"> / {{ g.grade_max }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </nb-card-body>
</nb-card>
